export default __webpack_public_path__ + "static/poster-5a5c2763830bb90611e96c8bdc5034e5.png";